// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"9d3cd43b","161":"f6a90a11","227":"67ac2b2d","277":"78c6f381","914":"ebb9dd61"}[chunkId] + ".chunk.js";
};